import styled from 'styled-components';

interface ISlide {
  show: boolean;
  startAnim: boolean;
  notShow?: boolean;
}

export const Container = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};
  background: linear-gradient(135deg, #fff 0%, #eee 100%), #dfdfdf;
  width: 100%;
  /* min-height: 551.25px; */
`;
